import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import addToTarget from 'rangeConfig/shared/behaviors/addToTarget';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import {
  matchDepth,
  matchHeight,
  matchType,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';
import { frameAttachment } from '../../filters/frameAttachment';
import { replaceFrame } from 'rangeConfig/kallax/behaviors/replaceFrame';
import { replaceUnderframe } from 'rangeConfig/kallax/behaviors/replaceUnderframe';
import { removeUnderframe } from 'rangeConfig/kallax/behaviors/removeUnderframe';
import { sortInteriors } from 'rangeConfig/kallax/sorting/sort';
import { getProductCardIconWithTooltip } from '../../utils/productCardUtils';

const frames = {
  id: 'frame-selected-menu',
  title: 'storageone.colorFilterLabel',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [replaceFrame],
    productDropped: [replaceFrame]
  },
  productTypes: [ProductType.KALLAX_FRAME, ProductType.KALLAX_TV_BENCH],
  productFilters: [matchWidth, matchHeight, matchDepth],
  productCardIcon: getProductCardIconWithTooltip
};

const desks = {
  id: 'desks-selected-menu',
  title: 'storageone.productListDesksTitle',
  cardSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [replaceFrame],
    productDropped: [replaceFrame]
  },
  productTypes: [ProductType.KALLAX_DESK],
  productFilters: [matchType]
};

const underframe = {
  id: 'frame-selected-menu-underframe',
  title: 'storageone.underframe',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [replaceUnderframe],
    productDropped: [replaceUnderframe]
  },
  productTypes: [ProductType.KALLAX_UNDERFRAME],
  productFilters: [matchWidth, frameAttachment],
  noneOption: {
    behaviors: { removeProducts: [removeUnderframe] },
    selected: () => false,
    title: 'storageone.productListNoUnderframeOptionTitle'
  }
};

const inserts = {
  cardsTitle: 'name',
  id: 'section-selected-menu-interiors',
  title: 'storageone.productListInsertsAndBoxesTitle',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [addToTarget],
    productDropped: [addProduct]
  },
  productTypes: [
    ProductType.KALLAX_DRAWERS,
    ProductType.KALLAX_BASKETS,
    ProductType.KALLAX_BOXES,
    ProductType.KALLAX_DIVIDERS,
    ProductType.KALLAX_CABINETS
  ],
  productFilters: [],
  cluster: ['globalItemNo'],
  sortClusteredProducts: sortInteriors,
  productCardIcon: getProductCardIconWithTooltip
};

const widgets = {
  desktop: [
    {
      id: 'display-size',
      title: 'storageone.sizeFilterLabel',
      component: DimensionsLabel
    },
    inserts,
    underframe,
    frames,
    desks
  ],
  mobile: [inserts, underframe, frames, desks]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseShelvingUnit',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform]
};

export default selectedMenu;
